module.exports = __webpack_public_path__ + "img/catfood_logo.ee9e0a65.png";